export default {
  GET_SUBCATEGORIES_REQUEST: '@@subcategories/GET_SUBCATEGORIES_REQUEST',
  GET_SUBCATEGORIES_SUCCESS: '@@subcategories/GET_SUBCATEGORIES_SUCCESS',
  GET_SUBCATEGORIES_ERROR: '@@subcategories/GET_SUBCATEGORIES_ERROR',
};
